import { defineMessages } from 'react-intl';

export default defineMessages({
  xpayPaypalSuccess: {
    id: 'xpayPaypalSuccess',
    defaultMessage: `PayPal is connected successfully`,
  },
  xpayPaypalError: {
    id: 'xpayPaypalError',
    defaultMessage: `Something went wrong with PayPal so your lifetime protection 
    hasn’t been activated. Please try again.`,
  },
});
